import { render, staticRenderFns } from "./LayoutBackofficeEmpty.vue?vue&type=template&id=450771a8"
import script from "./LayoutBackofficeEmpty.vue?vue&type=script&lang=js"
export * from "./LayoutBackofficeEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports